// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"27afad47","821":"a966108c"}[chunkId] + ".chunk.js";
};